<!-- 企业级-位置管理-位置列表 -->
<template>
  <div class="mainArea CSceneList">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 用户指引提示 -->
        <span class="tooltip" v-if="activeTab === 'scene' && sceneData.list.length === 0">请点击此处进行添加位置的操作</span>

        <!-- tabList -->
        <el-tabs class="tabList" v-model="activeTab" stretch>

          <!-- 设备 -->
          <el-tab-pane class="list user" label="设备" name="device">

            <!-- 内容左边区域 -->
            <div class="contentLeftArea">
              <!-- leftTopArea -->
              <div class="leftTopArea clearfix">
                <span class="text">设备</span>
              </div>
              <!-- 设备列表 -->
              <el-tree
                class="defineTree"
                v-loading="sceneData.loading"
                :data="sceneData.list"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
                :props="defaultProps"
                :empty-text="sceneData.emptyText"
                @node-click="deviceNodeClick">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <!-- 自定义icon -->
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                  <!-- :class="data.space_id === deviceData.selected[deviceData.selected.length-1] ? 'selected' : ''" -->
                  <!-- @click="getSpaceDeviceList(data.space_id, data.level)" -->
                  <span
                    class="label"
                    :class="data.space_id === deviceData.selected ? 'selected' : ''">{{ node.label }}</span>
                </span>
              </el-tree>
            </div>

            <!-- 内容右边区域 -->
            <div class="contentRightArea clearfix" v-if="sceneData.list.length !== 0">

              <!-- 按钮区域 -->
              <div class="btnArea">
                <!-- <el-button class="btn" @click="operateDialogInfo('addDevice')">添加设备</el-button>
                <el-button class="btn" @click="operateDialogInfo('batchZYDevice')">批量转移设备</el-button> -->
                <el-button class="btn" @click="expShowMsg">添加设备</el-button>
                <el-button class="btn" @click="expShowMsg">批量转移设备</el-button>
              </div>

              <!-- 设备列表 -->
              <el-table
                v-loading="deviceData.loading"
                :data="deviceData.list"
                style="width: 100%"
                @selection-change="selectionChange">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  type="index"
                  label="序号">
                </el-table-column>
                <el-table-column
                  prop="device_no_id"
                  label="设备ID">
                </el-table-column>
                <el-table-column
                  prop="device_name"
                  label="设备名称">
                </el-table-column>
                <el-table-column
                  prop="device_type"
                  label="设备类型">
                </el-table-column>
                <el-table-column
                  prop="space_name"
                  label="所属位置">
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot-scope="scope">
                    <!-- <el-button type="text" @click="operateDialogInfo('alterDevice', scope.row)">修改</el-button>
                    <el-button type="text" @click="operateDialogInfo('deleteDevice', scope.row)">删除</el-button> -->
                    <el-button type="text" @click="expShowMsg">修改</el-button>
                    <el-button type="text" @click="expShowMsg">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 分页 -->
              <div class="paging" v-if="deviceData.pageCount > 1">
                <el-pagination
                  @current-change="devicePageChange"
                  :current-page.sync="deviceData.paging.page"
                  layout="prev, pager, next, jumper"
                  :page-count="deviceData.pageCount">
                </el-pagination>
              </div>

            </div>

          </el-tab-pane>

          <!-- 位置 -->
          <el-tab-pane class="list" label="位置" name="scene">
            <!-- 内容左边区域 -->
            <div class="contentLeftArea">
              <!-- leftTopArea -->
              <div class="leftTopArea clearfix">
                <span class="text">位置</span>
                <!-- <i class="icon el-icon-circle-plus-outline" @click="operateDialogInfo('addSpace')"></i> -->
                <i class="icon el-icon-circle-plus-outline" @click="expShowMsg"></i>
              </div>
              <!-- 位置列表 -->
              <el-tree
                class="defineTree"
                v-loading="sceneData.loading"
                :data="sceneData.list"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
                :props="defaultProps"
                :empty-text="sceneData.emptyText"
                @node-click="sceneNodeClick">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <!-- 自定义icon -->
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                  <span
                    class="label"
                    :class="data.space_id === sceneData.selected ? 'selected' : ''"
                    @click="getSpaceInfo(data.space_id)">{{ node.label }}</span>
                  <!-- 修改、删除 -->
                  <span
                    class="operate"
                    >
                    <!-- <span class="text" @click="updateSpace('updateSpace', data, node.id)" v-show="node.level !== 1">修改</span>
                    <span class="text" @click="operateDialogInfo('deleteSpace', data, node.id)">删除</span> -->
                    <span class="text" @click="expShowMsg">修改</span>
                    <span class="text" @click="expShowMsg">删除</span>
                  </span>
                </span>
              </el-tree>
            </div>

            <!-- 内容右边区域 -->
            <div class="contentRightArea clearfix" v-if="sceneData.list.length !== 0">
              <p class="title">下级空间</p>
              <div class="updateWrapper">
                <ul class="updateBox clearfix" separator-class="el-icon-arrow-right">
                  <li class="item"
                    :style="{left: index + 'em'}"
                    v-for="(item, index) in sceneData.spaceInfo.parent"
                    :key="index"
                    @click="getSpaceInfo(item.space_id)">{{item.space_name}}</li>
                  <!-- 下级位置列表 -->
                  <ul
                    class="listWrapper"
                    :class="{hide: sceneData.spaceInfo.parent.length === 5}"
                    :style="{marginLeft: sceneData.spaceInfo.parent.length + 'em'}">
                    <li
                      class="list clearfix"
                      v-for="(cItem, cIndex) in sceneData.spaceInfo.children"
                      :key="cIndex">
                      <input type="text" class="name" v-model="cItem.space_name" disabled>
                      <!-- <i class="el-icon-delete" plain @click="openHintBox({cIndex: cIndex, cItem: cItem})"></i> -->
                      <i class="el-icon-delete" plain @click="expShowMsg"></i>
                    </li>
                    <!-- 添加按钮 -->
                    <!-- <li class="list add" @click="addSceneInput"> -->
                    <li class="list add" @click="expShowMsg">
                      <i class="el-icon-plus"></i>
                      添加
                    </li>
                    <!-- 确认按钮 -->
                    <!-- <el-button class="confirm" @click="operateDialogInfo('updateChildSpace', {})">确认</el-button> -->
                    <el-button class="confirm" @click="expShowMsg">确认</el-button>
                  </ul>
                  <!-- 下级位置列表为空 -->
                  <!-- <p class="listNull" :class="{hide: sceneData.spaceInfo.parent.length !== 5}">没有下级部门</p> -->
                </ul>
              </div>
            </div>
          </el-tab-pane>

        </el-tabs>

        <!--对话框-->
        <el-dialog
          :class="{maxDialog: dialogData.type === 'addSpace'|| dialogData.type === 'updateSpace', biometricsDialog: dialogData.type === 'updateSpace'}"
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">

          <!-- 新增位置 -->
          <div
            class="addSpaceDialog"
            v-if="dialogData.type === 'addSpace'">
            <!-- 步骤条 -->
            <el-steps :active="sceneData.addSceneStep" finish-status="success" align-center>
              <el-step title="设置地址"></el-step>
              <el-step title="设置空间"></el-step>
            </el-steps>

            <el-form
              label-width="100px"
              :model="dialogData.info">

              <!-- 步骤1 分配企业 -->
              <div class="step1" v-if="sceneData.addSceneStep === 0">
                <el-form-item label="地址:">
                  <div class="inputBox clearfix">
                    <el-select class="select" v-model="dialogData.info.country" @change="addressChange('country')">
                      <el-option
                        v-for="item in address.country"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <!-- 国内选择 -->
                    <div class="CSelect clearfix" v-if="dialogData.info.country === '1'">
                      <el-select class="select" v-model="dialogData.info.province" placeholder="省" @focus="getAreaList('province', dialogData.info.country)" @change="addressChange('province')">
                        <el-option
                          v-for="item in address.province"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select class="select" v-model="dialogData.info.city" placeholder="市" @focus="getAreaList('city', dialogData.info.province)" @change="addressChange('city')">
                        <el-option
                          v-for="item in address.city"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select class="select" v-model="dialogData.info.area" placeholder="区" @focus="getAreaList('area', dialogData.info.city)" @change="addressChange('area')">
                        <el-option
                          v-for="item in address.area"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                    <!-- 国外选择 -->
                    <el-select class="FSelectStreet" v-model="dialogData.info.street_id" @focus="getStreetList()" v-else>
                      <el-option label="新增具体街道" value=""></el-option>
                      <el-option
                        v-for="item in address.street"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <!-- 具体街道选择 -->
                <el-form-item
                  label="具体街道:"
                  v-if="!(dialogData.info.country === '2' && dialogData.info.street_id !== '')">
                  <div class="inputBox">
                    <!-- 国内 -->
                    <el-select class="CSelectStreet" v-model="dialogData.info.street_id" @focus="getStreetList()" v-if="dialogData.info.country === '1'">
                      <el-option label="新增具体街道" value=""></el-option>
                      <el-option
                        v-for="item in address.street"
                        :key="item.street_id"
                        :label="item.street_name"
                        :value="item.street_id">
                      </el-option>
                    </el-select>
                    <!-- 国内/国外 新增街道 -->
                    <el-input class="newStreet" v-model="dialogData.info.street_name" v-if="dialogData.info.street_id === ''"></el-input>
                  </div>
                </el-form-item>
                <el-form-item class="btnArea">
                  <el-button @click="dialogData.visible = false">取 消</el-button>
                  <el-button @click="next">下一步</el-button>
                </el-form-item>
              </div>

              <!-- 步骤2 确认配置信息 -->
              <div class="step2" v-if="sceneData.addSceneStep === 1">
                <el-form-item
                  label="上级空间:">
                  <div class="inputBox">
                    <div class="el-select CSelectStreet">
                      <div class="el-input el-input--suffix"
                       :class="{'is-focus': sceneData.showTree}">
                        <input
                          type="text"
                          readonly="readonly"
                          autocomplete="off"
                          placeholder="请选择"
                          class="el-input__inner"
                          v-model="sceneData.activeSpaceName"
                          @click="getSpaceListByStreet()">
                        <span class="el-input__suffix">
                          <span class="el-input__suffix-inner">
                            <i class="el-select__caret el-input__icon el-icon-arrow-up" 
                              :class="{'is-reverse': sceneData.showTree}"></i>
                          </span>
                        </span>
                      </div>
                      <div class="selectTreeWarraper" v-if="sceneData.showTree">
                        <el-tree
                          class="selectTree"
                          :data="address.street"
                          :props="defaultProps"
                          default-expand-all
                          @node-click="selectChild"></el-tree>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item
                  :label="sceneData.activeSpaceLevel === '' ? '新增一级空间:' : sceneData.activeSpaceLevel === '1' ? '新增二级空间:' : '新增三级空间:'">
                  <div class="inputBox">
                    <el-input class="newStreet" v-model="dialogData.info.space_name"></el-input>
                  </div>
                </el-form-item>
                <el-form-item class="btnArea">
                  <el-button class="prev" @click="prev">上一步</el-button>
                  <el-button type="primary" @click="addSpace">确 认</el-button>
                </el-form-item>

              </div>
            </el-form>
          </div>

          <!-- 删除空间 -->
          <div
            v-else-if="dialogData.type === 'deleteSpace'">
            <p class="text">
              确认要删除
              <span class="bold">
                {{dialogData.info.space_name}}
              </span>
              ？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteSpace()">确 认</el-button>
            </div>
          </div>

          <!-- 修改空间 -->
          <div
            class="addSpaceDialog"
            v-else-if="dialogData.type === 'updateSpace'">
            <el-form
              label-width="80px"
              :model="dialogData.info">
              <!-- 修改具体街道 -->
              <div v-if="dialogData.info.level === '0'">
                <el-form-item label="地址:">
                  <div class="inputBox clearfix">
                    <el-select class="select" v-model="dialogData.info.country" @change="addressChange('country')">
                      <el-option
                        v-for="item in address.country"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <div class="CSelect clearfix" v-if="dialogData.info.country === '1'">
                      <el-select class="select" v-model="dialogData.info.province" placeholder="省" @focus="getAreaList('province', dialogData.info.country)" @change="addressChange('province')">
                        <el-option
                          v-for="item in address.province"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select class="select" v-model="dialogData.info.city" placeholder="市" @focus="getAreaList('city', dialogData.info.province)" @change="addressChange('city')">
                        <el-option
                          v-for="item in address.city"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select class="select" v-model="dialogData.info.area" placeholder="区" @focus="getAreaList('area', dialogData.info.city)" @change="addressChange('area')">
                        <el-option
                          v-for="item in address.area"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                    <!-- 国外选择 -->
                    <el-select class="FSelectStreet" v-model="dialogData.info.street_id" @focus="getStreetList()" v-else>
                      <el-option label="新增具体街道" value=""></el-option>
                      <el-option
                        v-for="item in address.street"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item
                  label="具体街道:">
                  <div class="inputBox">
                    <el-input class="newStreet" v-model="dialogData.info.space_name"></el-input>
                  </div>
                </el-form-item>
              </div>
              <!-- 修改空间名称 -->
              <div v-else>
                <el-form-item
                  label="空间名称:">
                  <div class="inputBox">
                    <el-input class="newStreet" v-model="dialogData.info.space_name"></el-input>
                  </div>
                </el-form-item>
              </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="confirmUpdateSpace()">确 认</el-button>
            </div>
          </div>

          <!-- 右侧-下级空间-更新空间 -->
          <div
            v-else-if="dialogData.type === 'updateChildSpace'">
            <p class="text">
              确认更新数据？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancelUpdateChildSpace">取 消</el-button>
              <el-button @click="updateChildSpace">确 认</el-button>
            </div>
          </div>

          <!-- 添加/修改设备 -->
          <div
            v-if="dialogData.type === 'addDevice' || dialogData.type === 'alterDevice'">
              <el-form
              label-width="80px"
              :model="dialogData.info">
              <el-form-item label="设备ID:">
                <div class="inputBox">
                  <el-select
                    class="inputBox"
                    v-model="dialogData.info.device_no_id"
                    placeholder="请选择设备ID"
                    @focus="getDeviceList"
                    @change="getDeviceType">
                    <el-option
                      v-for="item in deviceData.deviceIdList"
                      :key="item.device_no_id"
                      :label="item.device_no_id"
                      :value="item.device_no_id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="所属位置:">
                <div class="inputBox">
                  <!-- <el-cascader
                    :options="deviceData.belongSceneList"
                    v-model="deviceData.selected"
                    :props="selectProps">
                  </el-cascader> -->
                  <!-- {{dialogData.info.space_id}} -->
                  <el-cascader
                    :options="deviceData.belongSceneList"
                    v-model="dialogData.info.selected"
                    :props="selectProps"></el-cascader>
                </div>
              </el-form-item>
              <el-form-item label="设备名称:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.device_name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="设备类型:">
                <div class="inputBox">
                  <p>{{dialogData.info.device_type}}</p>
                </div>
              </el-form-item>
              <template v-if="dialogData.info.device_type_code=='ACCESS'">
              <el-form-item label="门禁级别:">
                <el-select
                  class="inputBox"
                  v-model="dialogData.info.device_level"
                  placeholder="请选择门禁级别">
                  <el-option label="A" value="A"></el-option>
                  <el-option label="B" value="B"></el-option>
                  <el-option label="C" value="C"></el-option>
                </el-select>
                <div class="tips">
                  <span v-if="dialogData.info.device_level == 'A'">适用于领导办公室、私人仓库等私人领域，可用小程序进行远程一键开门</span>
                  <span v-else-if="dialogData.info.device_level == 'B'">适用于一般员工进出的部门大门等公共区域，只能通过现场扫码打开门禁，无法远程一键开门</span>
                  <span v-else>适用于访客也能进出的大门、楼道、公共会议室等门禁，访客通过预约后就能拥有所有级别为低的门禁权限</span>
                </div>
              </el-form-item>
              </template>
              <template v-if="dialogData.info.device_type_code=='OFFICIALDEPOSIT'">
              <el-form-item label="寄存模式:">
                <el-select
                  class="inputBox"
                  v-model="dialogData.info.device_level"
                  placeholder="请选择寄存模式">
                  <el-option label="专柜专用" value="0"></el-option>
                  <el-option label="随机箱格" value="1"></el-option>
                </el-select>
                <div class="tips">
                  <span>切换寄存模式后，设备会进行初始化，原来箱格已设置的权限将全部清空。</span>
                </div>
              </el-form-item>
              </template>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateDevice()">确 认</el-button>
            </div>
          </div>

          <!-- 删除设备 -->
          <div
            v-else-if="dialogData.type === 'deleteDevice'">
            <p class="text">
              是否删除设备
              <span class="bold">
                {{dialogData.info.device_name}}
              </span>
              ？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteDevice()">确 认</el-button>
            </div>
          </div>

          <!-- 批量转移设备 -->
          <div
            v-if="dialogData.type === 'batchZYDevice'">
              <el-form
              label-width="100px"
              :model="dialogData.info">
              <el-form-item label="转移设备数:">
                <div class="inputBox">
                  <p>{{deviceData.selection.length}}个</p>
                </div>
              </el-form-item>
              <el-form-item label="转移位置:">
                <div class="inputBox">
                  <el-cascader
                    :options="deviceData.belongSceneList"
                    v-model="dialogData.info.space_id"
                    :props="selectProps">
                  </el-cascader>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="transferDevice()">确 认</el-button>
            </div>
          </div>

        </el-dialog>
      </div>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast, showMsg, deepCopy } from "../../../../static/js/utility/utility.js"
  import * as expConfig from "../../../../static/js/exp/config.js"
  import { expSceneApi } from "../../../../static/js/exp/scene.js"
  let vm

  export default {
    name: 'ExpCSceneList',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        // 当前显示tab，默认显示设备
        activeTab: 'device',
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 设备数据
        deviceData:{
          // 分页数据  page为当前页，perPage为每页数量，space_id为空间id
          paging: {
            page: 1,
            perPage: 10
          },
          // list: [],
          list: expConfig.sceneDeviceData.list,
          loading: false,
          // 当前选中空间
          selected: 0,
          // 设备id列表
          deviceIdList: [],
          // 所属位置列表
          belongSceneList: [],
          // 批量转移设备信息
          selection: []
        },
        // 位置列表数据
        sceneData: {
          // 位置列表
          list: [],
          loading: false,
          // 当前选中位置（即空间）
          selected: 0,
          // 位置列表为空显示字段
          emptyText: '目前无任何位置，请点击上方标签栏“位置”进行位置的添加',
          // 添加位置步骤
          addSceneStep: 0,
          // 添加位置 - 当前选中空间名称、层级
          activeSpaceName: '',
          activeSpaceLevel: '',
          // 添加位置 - 上级空间显示状态
          showTree: false,
          // 下级空间 - 位置空间详情
          spaceInfo: {
            parent: [],
            children: []
          },
          // 下级空间 - 更新的位置信息
          updateData:{},
          // 下级空间 - 已删除的空间（位置）信息
          deleteInfo: []
        },
        // 地址信息
        address: {
          country: [
            {
              name: '国内',
              id: '1'
            },
            {
              name: '国外',
              id: '2'
            }
          ],
          province: [],
          city: [],
          area: [],
          street:[]
        },
        // 树形控件配置
        defaultProps: {
          children: 'children',
          label: 'space_name'
        },
        // 级联选择器配置
        selectProps: {
          label: 'space_name',
          value: 'space_id',
          children: 'children',
          checkStrictly: true 
        }
      }
    },
    mounted(){
      vm.getSceneList()
      vm.getSpaceInfo(vm.sceneData.selected)
    },
    created: async function () {
      vm = this
    },
    methods: {
      // 体验提示
      expShowMsg() {
        showMsg('体验环境下，该功能无法使用', 'warning')
      },
      // 操作对话框信息（添加或修改）dialogData
      operateDialogInfo: function (type, info) {
        // console.log('type', type)
        // console.log('info', info)
        // 添加位置信息
        let addSpaceInfo
        if (type === 'addSpace') {
          this.sceneData.showTree = false
          this.sceneData.addSceneStep = 0
          this.sceneData.activeSpaceName = '/'
          this.sceneData.activeSpaceLevel = ''
          addSpaceInfo = {
            country: '1',
            province: '',
            city: '',
            area: '',
            street_id: '',
            street_name: '',
            parent_space_id: '',
            space_name: ''
          }
          
        // 重置地址信息
        this.address = {
          country: [
            {
              name: '国内',
              id: '1'
            },
            {
              name: '国外',
              id: '2'
            }
          ],
          province: [],
          city: [],
          area: [],
          street:[]
        }
        }

        // 确认更新下级部门信息
        if (type === 'updateChildSpace') {
          let children = this.sceneData.spaceInfo.children
          // console.log('children', children)
          for (let i in children) {
            // 判断
            if (children[i].space_name === '') {
              showToast('空间名称不能为空！')
              return
            }
          }
        }

        // 添加设备信息
        let addDeviceInfo
        if (type === 'addDevice') {
          addDeviceInfo = {
            device_no_id: '',
            device_name: '',
            selected: this.deviceData.selected,
            device_type_code:'',
            device_level:''
          }
          if (this.deviceData.belongSceneList.length === 0) {
            showToast('请先添加公司！')
            return
          }
        }
        // 修改设备信息
        if (type === 'alterDevice') {
          info.selected = this.getSelected(info.space_id, 'returnn')
        }

        // 批量转移设备
        let batchZYDeviceInfo = {
          space_id: []
        }
        if (type === 'batchZYDevice' && this.deviceData.selection.length === 0) {
          showToast('请选择要批量转移的设备！')
          return
        }

        let title = type === 'addSpace' ? '添加位置' :
                    type === 'updateSpace' ? (info.level === '0' ? '修改地址' : '修改空间名称') :
                    type === 'updateChildSpace' ? '更新空间' :
                    type === 'addDevice' ? '添加设备' :
                    type === 'alterDevice' ? '修改设备' :
                    type === 'batchZYDevice' ? '批量转移设备' : ''
        this.dialogData = {
          type: type,
          title: title,
          visible: !(this.dialogData.visible),
          info: type === 'addSpace' ? addSpaceInfo :
                type === 'addDevice' ? addDeviceInfo :
                type === 'addUser' ? userInfo :
                type === 'batchZYDevice' ? batchZYDeviceInfo : deepCopy(info)
        }

        // if (type === 'alterDevice') {
        //   // this.getSelected(info.space_id)
        // }

        // console.log('this', this.dialogData)
      },

      /* 设备Tab */
      // 设备树形列表节点
      deviceNodeClick(data) {
        // this.getSelected(data.space_id)
        // this.getSpaceDeviceList(data.space_id, data.level)
        vm.deviceData.selected = data.space_id
      },
      // 获取当前选中的设备id组，公司开始计
      getSelected: function (space_id, returnn) {
        let vm = this
        let list = vm.deviceData.belongSceneList
        let selected = []
        // console.log('space_id', space_id)
        for (let s in list) {
          let floor = list[s].children
          if (space_id === list[s].space_id) {
            selected = [space_id]
          }
          for (let i in floor) {
            let section = floor[i].children
            if (space_id === floor[i].space_id) {
              selected = [list[s].space_id, space_id]
            }
            for (let j in section) {
              if (space_id === section[j].space_id) {
                selected = [list[s].space_id, floor[i].space_id, space_id]
              }
            }
          }
        }

        if (returnn) {
          return selected
        } else {
          vm.deviceData.selected = selected
        }
        
      },
      // 获取设备类型
      getDeviceType: function (val) {
        let that = this
        for (let i in this.deviceData.deviceIdList) {
          if (val === that.deviceData.deviceIdList[i].device_no_id) {
            that.dialogData.info.device_type = that.deviceData.deviceIdList[i].device_type
            that.dialogData.info.device_type_code = that.deviceData.deviceIdList[i].code
            if(that.deviceData.deviceIdList[i].code == 'ACCESS'){
              that.dialogData.info.device_level = 'A'
            } else if (that.deviceData.deviceIdList[i].code == 'OFFICIALDEPOSIT'){
              that.dialogData.info.device_level = '0'
            } else {
              that.dialogData.info.device_level = ''
            }
          }
        }
      },
      // 添加/修改设备
      updateDevice: async function () {
        let vm = this
        let type = vm.dialogData.type
        let info = vm.dialogData.info
        let space_id = vm.dialogData.info.selected[vm.dialogData.info.selected.length - 1]

        let data = {
          space_id: space_id,
          device_no_id: info.device_no_id,
          device_name: info.device_name,
          action: type === 'addDevice' ? 'add' : 'update '
        }
        if(info.device_type_code == 'ACCESS' || info.device_type_code == 'OFFICIALDEPOSIT'){
          data.device_level = info.device_level
        }
        // console.log('更新设备data', data)

        let res = await sceneApi.updateDevice(data)
        if (res.meta.code === 200) {
          showToast(vm.dialogData.title + '成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getSpaceDeviceList(vm.deviceData.selected[vm.deviceData.selected.length - 1])
        } else {
          showToast(res.meta.message)
        }

      },
      // 删除设备
      deleteDevice: async function () {
        let vm = this
        let data = {
          device_no_id: vm.dialogData.info.device_no_id
        }

        let res = await sceneApi.deleteDevice(data)
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getSpaceDeviceList(vm.deviceData.selected[vm.deviceData.selected.length - 1])
        } else {
          showToast(res.meta.message)
        }
      },
      // checkBox ---监听用户是否选中设备列表
      selectionChange(val) {
        this.deviceData.selection = []
        if(val.length === 0) {
          this.deviceData.selection = val;
        } else {
          for (let i in val) {
            this.deviceData.selection.push(val[i].device_no_id)
          }
        }
        // console.log('this.deviceData.selection', this.deviceData.selection)
      },
      // 批量转移设备
      transferDevice: async function () {
        let vm = this
        let data = {
          device_no_id: vm.deviceData.selection,
          space_id: vm.dialogData.info.space_id[vm.dialogData.info.space_id.length - 1]
        }
        // console.log('转移data', data)

        let res = await sceneApi.transferDevice(data)
        if (res.meta.code === 200) {
          showToast('转移设备成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getSpaceDeviceList(vm.deviceData.selected[vm.deviceData.selected.length - 1])
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取位置设备列表
      getSpaceDeviceList: async function (space_id, level) {
        let vm = this
        if (level < 1) return
        // vm.getSelected(space_id)
        
        // console.log('vm.deviceData.selected', vm.deviceData.selected)
        let data = vm.deviceData.paging
        data.space_id = space_id

        let res = await sceneApi.getSpaceDeviceList(data)
        if (res.meta.code === 200) {
          vm.deviceData.list = res.data.list
          vm.deviceData.pageCount = res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },
      // 位置设备列表当前页值改变，获取新位置设备列表
      devicePageChange(val) {
        // console.log(`当前页: ${val}`);
        this.getSpaceDeviceList(this.deviceData.selected[this.deviceData.selected.length - 1])
      },
      // 获取未绑定过的设备列表
      getDeviceList: async function () {
        let vm = this
        let res = await sceneApi.getDeviceList()
        if (res.meta.code === 200) {
          vm.deviceData.deviceIdList = res.data
        } else {
          showToast(res.meta.message)
        }
      },

      /* 位置Tab */
      // 获取位置列表
      getSceneList: async function (selected) {
        let vm = this
        let res = await expSceneApi.getSceneList()
        vm.sceneData.list = res.data
      },
      // 位置树形列表节点
      sceneNodeClick(data) {
        this.getSpaceInfo(data.space_id)
      },
      // 获取空间详情
      getSpaceInfo: async function (space_id) {
        let vm = this
        vm.sceneData.selected = space_id
        let data = {
          space_id: vm.sceneData.selected
        }

        // // 初始化更新数据
        // vm.sceneData.updateData = {
        //   space_id: vm.sceneData.selected,
        //   update: [],
        //   add: [],
        //   delete: []
        // }

        let res = await expSceneApi.getSpaceInfo(data)
        vm.sceneData.spaceInfo = res.data
        // 获取更新数据---更新的下级空间
        vm.sceneData.updateData.update = [...res.data.children]
      },
      // 处理位置数据
      processScene: function (data, selected) {
        let vm = this
        // console.log('tag', data.length !== 0 && vm.activeTab === 'device')
        // console.log('tag', data.length !== 0 && vm.activeTab === 'scene')
        vm.deviceData.belongSceneList = []
        if ( data.length !== 0 && vm.activeTab === 'device') {
            // 显示某个公司或其下级空间的设备列表
            let list = data
            // 获取所属位置列表
            for (let s in list) {
              let area =  list[s].children
                // console.log('area', area, list[s].space_name)
              for (let i in area) {
                let street = area[i].children
                // console.log('street', street, area[i].space_name)
                for (let j in street) {
                  let company = street[j]
                  // console.log('company', company, company.space_name )
                  vm.deviceData.belongSceneList.push(company)
                }
              }
            }
              // console.log('belongSceneList', vm.deviceData.belongSceneList)
            if (vm.deviceData.belongSceneList.length !== 0) {
              let space_id = vm.deviceData.belongSceneList[0].space_id
              vm.getSelected(space_id)
              vm.getSpaceDeviceList(space_id)
            }
          } else if (data.length !== 0 && vm.activeTab === 'scene') {
            // 更新已选中的空间信息
            if (selected) {
              vm.getSpaceInfo(selected)
            } else {
              // 默认更新第一个空间
              vm.getSpaceInfo(data[0].space_id)
            }
            
            // console.log('sceneData.list', vm.sceneData.list)
          }
      },
      // 选择上级空间（新增位置对话框中）
      selectChild(data) {
        // console.log(data);
        let vm = this
        vm.sceneData.activeSpaceName = data.space_name
        vm.sceneData.activeSpaceLevel = data.level
        vm.dialogData.info.parent_space_id = data.space_id
        vm.sceneData.showTree = false
        // console.log('tag', vm.dialogData.info)
      },
      // 当前地址变化
      addressChange: function (type) {
        let vm = this
        // 上级地址改变，清空下级地址信息
        vm.address.street = ''
        vm.dialogData.info.street_name = ''
        vm.dialogData.info.area = (type === 'city' || type === 'province' || type === 'country') ? '' : vm.dialogData.info.area
        vm.dialogData.info.city = (type === 'province' || type === 'country') ? '' : vm.dialogData.info.city
        vm.dialogData.info.province = type === 'country' ? '' : vm.dialogData.info.province
        
        // console.log('发生改变', vm.dialogData.info)
      },
      // 获取城市/地区列表
      getAreaList: async function (type, id) {
        // console.log('type', type, id)
        // console.log('info', this.dialogData.info)
        let vm = this
        // 判断上级地址是否选择
        if (id === '' && (type === 'city' || type === 'area')) {
          showToast(type === 'city' ? '请先选择省' : '请先选择市')
          return
        }
        let data = {
          id: id
        }
        // console.log('data', data)

        let res = await sceneApi.getAreaList(data)
        if (res.meta.code === 200) {
          if (type === 'province') {
            vm.address.province = res.data
          } else if (type === 'city') {
            vm.address.city = res.data
          } else if (type === 'area') {
            vm.address.area = res.data
          } else if (type === 'street') {
            vm.address.street = res.data
          }
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取街道列表
      getStreetList: async function () {
        let vm = this
        let info = vm.dialogData.info
        // console.log('vm.dialogData.info', vm.dialogData.info)
        if (info.country === '1' && info.area === '') {
          showToast('请选择区')
          return
        }
        let data = {
          country: info.country,
          area: info.area
        }

        let res = await sceneApi.getStreetList(data)
        if (res.meta.code === 200) {
          vm.address.street = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      // 根据街道获取空间列表
      getSpaceListByStreet: async function () {
        let vm = this
        vm.sceneData.showTree = !(vm.sceneData.showTree)
        vm.address.street = []
        let data = {
          street_id: vm.dialogData.info.street_id
        }

        let res = await sceneApi.getSpaceListByStreet(data)
        if (res.meta.code === 200) {
          vm.address.street = res.data
          // console.log('vm.address.street', vm.address.street)
        } else {
          showToast(res.meta.message)
        }
        vm.address.street.unshift({space_name: '/', space_id: '', level: ''})
      },
      // 下一步
      next: function () {
        let info = this.dialogData.info
        // console.log('info', info)
        // for (let i in this.address.province) {
        //   console.log('tag', this.address.province[i].id, typeof(this.address.province[i].id))
        // }
        // return
        if (info.country === '1') {
          if (info.province === '') {
            showToast('请选择省！')
            return
          }
          if (info.city === '') {
            showToast('请选择市！')
            return
          }
          if (info.area === '') {
            showToast('请选择区！')
            return
          }
        }
        if (info.street_id === '' && info.street_name === '') {
          showToast('请填写具体街道！')
          return
        }

        // 执行下一步
        if (this.sceneData.addSceneStep++ > 2) this.sceneData.addSceneStep = 0;
      },
      // 上一步
      prev() {
        // console.log('this.address', this.address)
        if (this.sceneData.addSceneStep-- < 0) this.sceneData.addSceneStep = 0;
      },
      // 新增位置
      addSpace: async function () {
        let vm = this
        let data = vm.dialogData.info

        // console.log('data', data)
        // return
        if (data.space_name === '') {
          showToast('请输入空间名称！')
          return
        }
        let res = await sceneApi.addSpace(data)
        if (res.meta.code === 200) {
          showToast('添加位置成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getSceneList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 修改空间
      updateSpace: function (type, info) {
        let vm = this
        // console.info('info', info)
        vm.dialogData.info = deepCopy(info)
        if (type === 'updateSpace') {
          if (info.country === '1' &&info.level === '0') {
            vm.getAreaList('province', info.country)
            vm.getAreaList('city', info.province)
            vm.getAreaList('area', info.city)
          }
        }
        this.operateDialogInfo(type, info)        
      },
      // 修改空间
      confirmUpdateSpace: async function () {
        let vm = this
        let data = {
          space_id: vm.dialogData.info.space_id,
          space_name: vm.dialogData.info.space_name,
          country: vm.dialogData.info.country,
          province: vm.dialogData.info.province,
          city: vm.dialogData.info.city,
          area: vm.dialogData.info.area
        }

        let res = await sceneApi.updateSpace(data)
        if (res.meta.code === 200) {
          showToast('修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getSceneList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 删除空间
      deleteSpace: async function () {
        let vm = this
        let data = {
          space_id: vm.dialogData.info.space_id
        }

        let res = await sceneApi.deleteSpace(data)
        vm.dialogData.visible = !(vm.dialogData.visible)
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.getSceneList()
        } else {
          const h = vm.$createElement
          vm.$notify({
            title: '提示',
            message: h('i', { style: 'color: teal'}, '该空间下已关联了设备，请把设备转移到其他空间后再删除')
          })
        }
      },
      // 添加下级空间input
      addSceneInput: function () {
        let vm = this
        let addInfo = {
          space_id: '',
          space_name: ''
        }
        vm.sceneData.spaceInfo.children.push(addInfo)
        // console.log('vm.sceneData.spaceInfo.children', vm.sceneData.spaceInfo.children)
      },
      // 右侧 -- 删除部门信息提示框
      openHintBox(info) {
        // console.log('info', info)
        // 已绑定设备
        if (info.cItem.bind_device) {// 提示
          const h = this.$createElement;
          this.$notify({
            title: '提示',
            message: h('i', { style: 'color: teal'}, '该空间下已关联了设备，请把设备转移到其他空间后再删除')
          })
        } else {
          // 未绑定设备，可删除空间
          this.deleteSceneInput(info.cIndex, info.cItem)
        }
      },
      // 删除下级空间input
      deleteSceneInput: function (index, cItem) {
        let vm = this
        vm.sceneData.spaceInfo.children.splice(index, 1)
        // 删除的下级空间有space_id
        if (cItem.space_id !== '') {
          // 获取更新下级空间数据---添加的下级空间
          vm.sceneData.updateData.update.splice(index, 1)
          vm.sceneData.updateData.delete.push(cItem.space_id)
          vm.sceneData.deleteInfo.push({index: index, cItem: cItem})
        }
        // console.log('删除vm.sceneData.spaceInfo.children', vm.sceneData.spaceInfo.children)
      },
      // 取消更新下级空间
      cancelUpdateChildSpace: function () {
        let vm = this
        // console.log('前vm.sceneData.updateData', vm.sceneData.updateData)
        let deleteInfo = [...vm.sceneData.deleteInfo]
        console.log('deleteInfo', deleteInfo)
        // 取消删除，显示之前删除的已存在的信息
        deleteInfo.forEach(function (item, index) {
          // console.log('item', item, index)
          vm.sceneData.spaceInfo.children.splice(item.index, 0, item.cItem)
          vm.sceneData.updateData.update.splice(item.index, 0, item.cItem)
          vm.sceneData.updateData.delete = []
        })
        
        // console.log('后vm.sceneData.updateData', vm.sceneData.updateData)
        
        vm.dialogData.visible = false
        // 清空删除信息
        vm.sceneData.deleteInfo = []
      },
      // 确认更新下级空间
      updateChildSpace: async function () {
        let vm = this
        let data = vm.sceneData.updateData

        // 获取需增加的下级空间
        let children = vm.sceneData.spaceInfo.children
        data.add = []
        for (let i in children) {
          // 获取更新部门数据---添加的部门
          if (children[i].space_id === '') {
            data.add.push(children[i].space_name)
          }
        }

        let res = await sceneApi.updateChildSpace(data)
        if (res.meta.code === 200) {
          showToast('修改成功')
          vm.getSceneList(vm.sceneData.selected)
          vm.dialogData.visible = false
        } else {
          showToast(res.meta.message)
        }
        // console.log('children', children)
        // console.log('data', data)
      },
    },
    computed: {
    },
    watch: {
      // 监听vuex的值变化
      "activeTab": function(newVal) {
      },
    }
  }
</script>

<style lang="scss">
.CSceneList {
  .mainBodyContent::after{
    height: calc(100% - 40px);
    content: '';
    border-right: 1px solid #E4E7ED;
    position: absolute;
    left: 270px;
    top: 40px;
  }
  .tips{
    color: #F56C6C;
    line-height: 24px;
  }
  .mainBodyContent{
    padding: 0;
    position: relative;
    // tab列表
    .tabList {
      width: 100%;
      // 权限tab
      .list.user {
        .contentRightArea {
          padding: 20px 20px 0 0;
          .searchArea {
            width: 100%;
            .text {
              width: 200px;
              float: left;
              margin-right: 20px;
            }
            .searchBtn {
              float: left;
            }
          }
          .btnArea{
            margin: 10px 0;
          }
        }
        
      }
      // tabs标签
      .el-tabs__header {
        width: 100%;
        margin-bottom: 0;
        box-sizing: border-box;
        border-bottom: 1px solid #E4E7ED;
        .el-tabs__nav-wrap {
          padding-left: 20px;
          width: 360px;
        }
        .el-tabs__item {
          font-size: 18px;
        }
      }
    }
    // 内容左边
    .contentLeftArea {
      float: left;
      width: 270px;
      box-sizing: border-box;
      // border-right: 1px solid #E4E7ED;
      // 添加
      .leftTopArea{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 20px 0 10px;
        border-bottom: 1px solid #E4E7ED;
        .text{
          float: left;
          font-weight: bold;
        }
        .icon {
          float: right;
          display: block;
          font-size: 20px;
          line-height: 40px;
        }
      }
      // 部门列表为空
      .contentNull {
        text-align: center;
        margin-top: 100px;
        padding: 0 20px;
        color: #cccccc;
        font-size: 14px;
      }
    }
    // 内容右边
    .contentRightArea {
      padding: 0 10px 10px;
      margin-left: 300px;
      .title {
        line-height: 40px;
        font-weight: bold; 
      }
      .updateWrapper {
        margin-top: 15px;
        .updateBox {
          .item {
            // float: left;
            padding-left: 20px;
            font-size: 14px;
            line-height: 2;
            color: #606266;
            position: relative;
          }
          .item:first-child{
            padding-left: 0;
          }
          .item::before{
            content: '>';
            display: block;
            width: 20px;
            text-align: center;
            position: absolute;
            left: 0;
          }
          .item:first-child::before{
            content: '';
          }
        }
        // 下级部门列表 
        .listWrapper{
          float: left;
          width: 320px;
          padding-left: 20px;
          position: relative;
          .list{
            width: 100%;
            margin-bottom: 10px;
            .name {
              float: left;
            }
            .el-icon-delete{
              display: block;
              float: left;
              font-size: 18px;
              margin: 8.5px 0 8.5px 10px;
            }
          }
          .list .name,
          .list.add {
            width: 270px;
            font-size: 14px;
            height: 35px;
            line-height: 35px;
            padding-left: 5px;
            border: 1px solid #c0c4cc;
          }
          .list.add {
            border-style: dashed;
            text-align: center;
            color: #c0c4cc;
          }
          .confirm {
            padding: 9px 20px;
            border-radius: 0;
            margin-top: 10px;
          }
        }
        .listWrapper::before{
          color: #606266;
          content: '>';
          display: block;
          width: 20px;
          text-align: center;
          position: absolute;
          left: 0;
        }
        // 下级部门列表为空
        .listNull {
          float: left;
          text-align: center;
          font-size: 14px;
          line-height: 1;
          color: #cccccc;
        }
      }
    }

    // 对话框
    .maxDialog {
      .el-dialog {
        width: 800px;
      }
      .addSpaceDialog {
        .inputBox {
          width: 100%;
        }
        .select,
        .CSelect,
        .selectStreet {
          float: left;
        }
        .select {
          width: 150px;
          margin-right: 15px;
        }
        .CSelectStreet,
        .newStreet {
          width: 645px;
        }
        .CSelectStreet {
          position: relative;
          margin-bottom: 10px;
        }
        .btnArea {
          text-align: center;
          margin-left: -100px;
        }
        .selectTreeWarraper {
          width: 100%;
          margin: 5px 0;
          border-radius: 4px;
          border: 1px solid #e4e7ed;
          background-color: #fff;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          box-sizing: border-box;
          position: absolute;
          top: 40px;
          z-index: 999;
          .text,
          .el-tree-node__content {
            font-size: 14px;
            height: 34px;
            line-height: 34px;
          }
          .text {
            padding-left: 10px;
          }
        }
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/ExpPage/CSceneManage/CSceneList.vue